import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ConfigurationApiService } from '../../../generated/api/configuration/configuration.service';

@Component({
    selector: 'elem-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent {

    urlFooterImpressum = '';
    urlFooterDatenschutz = '';
    urlFooterHilfe = '';

    contactPersonName = 'Avalmanagement';
    contactNumber = '+495119074260';
    contactNumberFormatted = '0511 / 907 4260';
    contactEmail = 'servicekaution@vhv.de';
    contactEmailFormatted = 'ServiceKaution@vhv.de';

    constructor(
        private readonly configurationApiService: ConfigurationApiService,
    ) {
        this.configurationApiService.getConfiguration().subscribe(configuration => {
            this.urlFooterImpressum = configuration.urlFooterImpressum;
            this.urlFooterDatenschutz = configuration.urlFooterDatenschutz;
            this.urlFooterHilfe = configuration.urlInterneHilfe;
        });
    }

}
